<template>

  <div>
    <m-icon v-if="item.children.length !== 0" dir="ltr" :icon="item.icon_class"/>

    <b-dropdown :text="item.name" variant="transparent" class="rounded nav-100-dropdown m-0 p-0"
                v-if="item.children.length !== 0">
      <m-a dir="ltr" :href="child.url" v-for="child in item.children" :key="child.id"
           class="nav-100-link text-white nav-100-link--page">
        {{ child.name }}
        <m-icon dir="ltr" :icon="child.icon_class"/>
      </m-a>
    </b-dropdown>

    <m-a :href="item.url" dir="ltr" class="nav-100-link nav-100-link--page" v-else>{{ item.name }}
      <m-icon dir="ltr" :icon="item.icon_class"/>
    </m-a>

  </div>

</template>

<script>

export default {
  name: "NavMenuItem",
  props: ['item'],
}
</script>

<style>
.nav-100-pages-nav__item button {
  color: white;
}

.nav-100-pages-nav__item button:hover {
  color: white;
}

.nav-100-dropdown .nav-100-link--page {
  display: block;
  color: black !important;
  text-align: center;
  padding-top: 10px;
}

.nav-100-dropdown .dropdown-toggle:after {
  margin-right: 5px;
}
</style>